import create from 'zustand';

import { EUR, USD } from '@/config/appConstants';
import { GeoClientData } from '@/lib/AbstractAPI/types';
import { Currency } from '@/types';

type GeoLocation = {
  geoLocation: GeoClientData;
  isSet: boolean;
  getGeoLocation: () => GeoClientData;
  setGeoLocation: (geoLocation: GeoClientData) => void;
  getGeoLocationCurrencyCode: () => Currency;
};

export const useGeoLocation = create<GeoLocation>((set, get) => ({
  geoLocation: {} as GeoClientData,
  isSet: false,
  getGeoLocation: (): GeoClientData => {
    return get().geoLocation;
  },

  setGeoLocation: (geoLocation: GeoClientData) => {
    if (geoLocation === get().geoLocation) return;
    set(() => ({
      isSet: true,
      geoLocation: geoLocation,
    }));
  },

  getGeoLocationCurrencyCode: (): Currency => {
    const currency = get().geoLocation.country.currency;

    return currency.toUpperCase() === EUR.toUpperCase() ? EUR : USD;
  },
}));
